import type { EventHint, ErrorEvent } from "@sentry/types";

import { batBeacon } from "../filters/batBeacon/batBeacon";
import { chunkLoadError } from "../filters/chunkLoadError/chunkLoadError";
import { objectMatchingId } from "../filters/objectMatchingId/objectMatchingId";
import { resizeObserverLoop } from "../filters/resizeObserverLoop/resizeObserverLoop";
import { thirdPartyDomains } from "../filters/thirdPartyDomains/thirdPartyDomains";
import { errorsTurnedOffFilter } from "../filters/turnErrorsOff/turnErrorsOff";
import { webkitMessageHandlers } from "../filters/webkitMessageHandlers/webkitMessageHandlers";

const filters = {
  batBeacon,
  chunkLoadError,
  thirdPartyDomains,
  objectMatchingId,
  resizeObserverLoop,
  errorsTurnedOffFilter,
  webkitMessageHandlers,
};

type Filters = keyof typeof filters;

export const beforeSend = (event: ErrorEvent, hint: EventHint, excludeFilters: Filters[] = []) => {
  for (const [name, filter] of Object.entries(filters)) {
    if (excludeFilters.includes(name as Filters)) continue;
    if (!filter) continue;

    const result = filter(event, hint);
    if (!result) return null;
  }

  return event;
};
